<template>
  <el-row class="core_two_wrap">
    <el-col class="two_left">
      <div class="left_tit">
        {{ core.subTitle }}
      </div>
      <div class="left_desc" v-html="core.desc"></div>
      <el-row class="icon_wrap">
        <el-col class="icon_item" v-for="item in core.children.slice(0, 4)">
          <div v-html="item">
          </div>
        </el-col>
      </el-row>
      <el-row class="icon_wrap">
        <el-col class="icon_item" v-for="item in core.children.slice(4, 7)">
          <div v-html="item">
          </div>
        </el-col>
      </el-row>
      <el-row class="icon_wrap">
        <el-col class="icon_item" v-for="item in core.children.slice(7)">
          <div v-html="item">
          </div>
        </el-col>
      </el-row>
    </el-col>
    <el-col class="two_right">
      <img src="@/assets/img/right2.png" alt="" />
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    core: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.core_two_wrap {
  display: flex;
  justify-content: center;
  text-align: left;

  @media screen and (max-width: 768px) {
    flex-wrap: wrap;
  }

  .two_left {
    width: 40%;
    padding: 20px 50px 20px 50px;

    @media screen and (max-width: 768px) {
      width: 95%;
    }

    .left_tit {
      font-size: 23px;
      font-weight: bold;
      color: #3e3e3e;

      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        margin-top: 20PX;
      }
    }

    .left_desc {
      color: #717171;
      padding: 30px 40px 20px 40px;
      line-height: 25px;
      font-size: 18px;
      margin-bottom: 20px;

      @media screen and (max-width: 768px) {
        padding: 30PX 0;
        font-size: 1rem;
        line-height: 1.2rem;
      }

      ::v-deep span {
        color: #ffa400;
        font-size: 24px;
        padding: 0 10px;

        @media screen and (max-width: 768px) {
          font-size: 1.2rem;
        }
      }
    }

    ::v-deep .icon_wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      &:nth-child(n+2) {
        margin-top: -20px;
      }

      .icon_item {
        background: url('../../assets/img/types.png') 0 0 no-repeat;
        background-size: 100% 100%;
        width: 120px;
        height: 135px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-right: 10px;

        @media screen and (max-width: 768px) {
          width: 20%;
          height: 73PX;
          margin-right: 10PX;
        }

        .icon_title {
          color: #717171;
          font-size: 22px;
          font-weight: bold;

          @media screen and (max-width: 768px) {
            font-size: 0.9rem;
            white-space: nowrap;
          }
        }

        .icon_desc {
          color: #717171;
          font-size: 14px;
          margin-top: 12px;

          @media screen and (max-width: 768px) {
            font-size: 0.7rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .two_right {
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 768px) {
      width: 100%;
      margin-top: 20PX;
    }

    img {
      width: 65%;
      margin-top: 70px;
    }
  }
}
</style>